import styles from './CircularProgressBar.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';

import CircularProgress from '@material-ui/core/CircularProgress';

import { ProgressBarProps } from '../ResponsiveProgressBar';

export const CircularProgressBar: React.FC<ProgressBarProps> = ({
  steps,
  currentStep,
}) => {
  const { t } = useTranslation();

  const completed = (currentStep / steps.length) * 100;
  const step = steps[currentStep - 1];
  const nextStep = steps[currentStep];

  return (
    <div className={styles.circularProgressBar}>
      <div className={styles.progressContainer}>
        <CircularProgress
          variant="determinate"
          className={styles.bottom}
          size={60}
          thickness={2}
          value={100}
          aria-label={t('ciruclar-progress-bar-bottom')}
        />
        <CircularProgress
          disableShrink
          variant="determinate"
          className={styles.top}
          classes={{
            circle: styles.circle,
          }}
          size={60}
          value={completed}
          thickness={2}
          aria-label={t('ciruclar-progress-bar-circle')}
        />
        <div className={styles.progressLabel}>
          <span>{t('progress-bar-step-progress', { step: currentStep, steps: steps.length })}</span>
        </div>
      </div>
      <div className={styles.stepContainer}>
        <h5 className={styles.stepTitle}>{t(step.title)}</h5>
        {nextStep && <p className={styles.nextStepTitle}>{t('next')}: {t(nextStep.title)}</p>}
      </div>
    </div>
  );
};
